import Vue from "vue";
import Vuetify from "vuetify/lib";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        appRed: "#FF6B6B",
        appGreen: "#23A0A0",
        appGrey: "#EDF1F4",
        appDarkGrey: "#DADADA",
        appBgGrey: "#F7F8F9",
        appOrange: "#FFBA49",
        appLightGrey: "#F9F9F9",
        appLightGrey100: "D3D3D3",
        appMuted: "#978D8D"
      }
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: "md"
  }
});
